import type { IconSvgObject } from './types';

const UserRoadsideIcon: IconSvgObject = [
  ["path", { d: "M6.5 16.8468H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 21V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 16.8468H17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 13.5H9L10.5 18.5H13.5L15 13.5H17V12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12V13.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["circle", { cx: "12", cy: "4.5", r: "2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default UserRoadsideIcon;
